module.exports = __webpack_public_path__ + "static/img/t6.62433642.png";